import {
    GET_BLOCKED_START,
    GET_BLOCKED_SUCCESS,
    GET_BLOCKED_ERROR
} from '../../constants';
import { UserListing as query, ListingDataUpdate as mutation } from '../../lib/graphql';

export const getListBlockedDates = (
    listId,
    minDayValues,
    maxDayValues,
    checkInEndValue,
    checkInStartValue,
    houseRules,
    isCancel,
    isMaxDays,
    isBooking,
    basePrice,
    delivery,
    currency,
    monthlyDiscount,
    weeklyDiscount,
    securityDeposit
) => {
    return async (dispatch, getState, { client }) => {
        try {

            dispatch({
                type: GET_BLOCKED_START,
            });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    id: listId,
                    minDay: minDayValues,
                    maxDay: maxDayValues,
                    checkInStart: checkInStartValue,
                    checkInEnd: checkInEndValue,
                    houseRules: houseRules,
                    cancellationPolicy: parseInt(isCancel),
                    maxDaysNotice: isMaxDays,
                    bookingNoticeTime: String(isBooking),
                    basePrice: parseFloat(basePrice),
                    delivery: parseFloat(delivery),
                    currency: currency,
                    monthlyDiscount: monthlyDiscount ? parseFloat(monthlyDiscount) : 0,
                    weeklyDiscount: weeklyDiscount ? parseFloat(weeklyDiscount) : 0,
                    securityDeposit: securityDeposit ? parseFloat(securityDeposit) : 0
                },
                refetchQueries: [{ query, variables: { listId: listId, preview: true } }]
            });

            if (data?.ListingDataUpdate) {
                if (data?.ListingDataUpdate?.status === 'success') {
                    dispatch({
                        type: GET_BLOCKED_SUCCESS,
                    });
                    return true;
                } else {
                    return false;
                }
            }

        } catch (error) {
            dispatch({
                type: GET_BLOCKED_ERROR,
                payload: {
                    error
                }
            });
        }
    };
}